<div class="time-range-picker-container">
  <label class="picker-label" *ngIf="label">{{ label }}</label>

  <div class="picker-input-box" [class.panel-is-open]="isDropdownOpen" (click)="toggleDropdown()">
    <span class="icon-calendar">📅</span>
    
    <div class="display-text-wrapper">
      <span class="time-text-segment" [innerHTML]="getStartDisplayValue()"></span>
      <span class="arrow-separator">→</span>
      <span class="time-text-segment" [innerHTML]="getEndDisplayValue()"></span>
    </div>

    <span class="arrow-dropdown" [class.rotate-arrow]="isDropdownOpen">▼</span>
  </div>

  <div class="picker-dropdown-panel" *ngIf="isDropdownOpen">
    <div *ngIf="warningMessage" class="notice-message mb-4">
      {{ warningMessage }}
    </div>
    <div class="panels-layout">
      
      <div class="time-column-panel">
        <div class="panel-header start">From (Start)</div>
        <div class="date-input-block">
          <input type="date" placeholder="From Date" [(ngModel)]="startDate" (change)="emitDateTimeRange()" class="form-date-input" />
        </div>
        <div class="selectors">
          <div class="select-block">
            <label>Hour</label>
            <select [(ngModel)]="startHr" (change)="emitDateTimeRange()">
              <option value="" disabled selected>--</option>
              <option *ngFor="let hr of hours" [value]="hr">{{ hr }}</option>
            </select>
          </div>
          
          <div class="select-block">
            <label>Minute</label>
            <select [(ngModel)]="startMin" (change)="emitDateTimeRange()">
              <option value="" disabled selected>--</option>
              <option *ngFor="let min of minutes" [value]="min">{{ min }}</option>
            </select>
          </div>
          
          <div class="select-block ampm-block">
            <label>Period</label>
            <select [(ngModel)]="startAmPm" (change)="emitDateTimeRange()">
              <option value="" disabled selected>--</option>
              <option value="AM">AM</option>
              <option value="PM">PM</option>
            </select>
          </div>
        </div>
      </div>

      <div class="panel-divider"></div>

      <div class="time-column-panel">
        <div class="panel-header end">To (End)</div>
        <div class="date-input-block">
          <input type="date" [(ngModel)]="endDate" (change)="emitDateTimeRange()" class="form-date-input" />
        </div>
        <div class="selectors">
          <div class="select-block">
            <label>Hour</label>
            <select [(ngModel)]="endHr" (change)="emitDateTimeRange()">
              <option value="" disabled selected>--</option>
              <option *ngFor="let hr of hours" [value]="hr">{{ hr }}</option>
            </select>
          </div>
          
          <div class="select-block">
            <label>Minute</label>
            <select [(ngModel)]="endMin" (change)="emitDateTimeRange()">
              <option value="" disabled selected>--</option>
              <option *ngFor="let min of minutes" [value]="min">{{ min }}</option>
            </select>
          </div>
          
          <div class="select-block ampm-block">
            <label>Period</label>
            <select [(ngModel)]="endAmPm" (change)="emitDateTimeRange()">
              <option value="" disabled selected>--</option>
              <option value="AM">AM</option>
              <option value="PM">PM</option>
            </select>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
